import React,{useState, useEffect} from "react";
import { Link, useNavigate } from 'react-router-dom'
import axios from "axios";
import { api, eventURL, WorkshopListURL } from "../../../apis/urls";
import Loader from "../../../common-components/loader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities";
import moment from "moment/moment";
import { Table, Toggle,Pagination } from "rsuite";
import { Fragment } from "react-read-more-read-less";
import { message } from "antd";

const { Column, HeaderCell, Cell } = Table;

const WorkshopComponent = () => {

    const [added, setAdded] = useState(false);
    const [publish, setPublish] = useState('');

    const [pageno, setPageno] = useState(0);

    useEffect(() => {
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        setLoader(true);
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        setTimeout(() => {
            Listing();
            });
    }, []);

    const [loader,setLoader] = useState(true);
    const [result,setResult] = useState([]);
    const [searchTitle, setSearchTitle] = useState("");
    const [alertText, setAlertText]=useState("");
    const [currentpage, setCurrentpage] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [totalItems, setTotalItems] = useState([]);
    const [emptyItem, setEmptyItem] = useState(false);


    let counts = 0;
    if(result)
    {
        counts = result.length;
    }


    let navigate = useNavigate();

    const Listing = () => {

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: WorkshopListURL+'?page='+pageno+'&size='+10,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{

            if(response.data.message === "Success"){            
                console.log("current page ===>", response.data.currentPage);
                setResult(response.data.data.sort((a, b) => b.createdAt.localeCompare(a.createdAt)));
                setCurrentpage(response.data.currentPage)
                setTotalPages(response.data.totalPages)
                setTotalItems(response.data.totalItems)
                setLoader(false)
                }else{
                setResult(false);
                setLoader(false);
            }

           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }


    const PublishStatusSubmit = (id) => {

        let token = "Bearer "+localStorage.getItem('token');
        const instance = axios.create({
            baseURL: WorkshopListURL+'/publish/'+id,
            timeout: 1000000,
            headers: {'authorization': token}
          });
          instance.patch('').then((response) =>{

            message.success('Published successfully')

            Listing();

            setPublish(response.data.publish_status)
            console.log("Success", response.data)
          }).catch((error) =>{   
            console.log('error',error.message)  
          });
    }



        let token = "Bearer "+localStorage.getItem('token');
        const instances = axios.create({
            baseURL: api,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        const findByTitles = name => {
            return instances.get(`workshop/workshop?search=${name}`);
        };

        const onChangeSearchTitle = (e) => {
            const searchTitle = e.target.value;
            setSearchTitle(searchTitle);
            findByTitles(searchTitle)
            .then(response => {
                if(response.data.message=== "Success"){
                    setResult(response.data.data)
                    setCurrentpage(response.data.currentPage)
                    setTotalPages(response.data.totalPages)
                    setTotalItems(response.data.totalItems)
                }else{
                    setResult(false)
                }
            })
            .catch(e => {
                console.log(e);
            });
        };

        const findByTitlesss = option => {
            return instances.get(`workshop/workshop?status=${option}`);
        };

        const onChangeSearchTitles = (e) => {
            const searchTitle = e.target.value;
            findByTitlesss(searchTitle)
            .then(response => {
                if(response.data.message=== "Success"){
                    setResult(response.data.data)
                    setCurrentpage(response.data.currentPage)
                    setTotalPages(response.data.totalPages)
                    setTotalItems(response.data.totalItems)
                }else{
                    setResult(false)
                }
            })
            .catch(e => {
                console.log(e);
            });
        };


    //PAGINATION


     // Invoke when user click to request another page.
     const handlePageClick = (event) => { console.log('EVENTSSS',event)

     $('html,body').animate({ scrollTop: 0 }, 'fast');


     setPageno(event.selected)
     const instance = axios.create({

         baseURL: WorkshopListURL+`?search=`+searchTitle+'&page='+event.selected+'&size='+10,

         timeout: 1000000,
         headers: {'authorization': token}
     });

     instance.get('').then(res => {

         setResult(res.data.data)
         setCurrentpage(res.data.currentPage)
         setTotalPages(res.data.totalPages)
         setTotalItems(res.data.totalItems)
         setLoader(false);

     }).catch(e => {
        localStorage.removeItem('token')
     navigate("/")
     });
 };

 let dates = new Date();



    let sl =1;
    return (
        <div className="wrapper">
            <aside className="right-side ">
                <div class="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            <i className="icon-suitcase1"></i>
                            <h2 className="page-title">Conference Manager</h2>
                        </div>

                        <div class="page-rightside-action-column">
                            <div class="input-groups mt-3 mb-3 search-grps">
                            <input type="text" 
                            class="form-controls search-bar asso-search"             
                            value={searchTitle}
                            onChange={onChangeSearchTitle}
                            placeholder="Search" />
                            <button  class="btn btn-search icon-search assosearch-btn"></button>
                            </div>
                            <Link to="/add_workshop" data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New Workshop"><i class="icon-add"></i><span>Add New Event</span> </Link>
                        </div>

                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            
                            <li className="breadcrumb-item active" aria-current="page">Events and Workshops</li>
                        </ol>
				    </nav>

                        {result?
                        (<div class="number-of">
                            Displaying 1-{counts} of {totalItems} results.
                        </div>):null
                        }


                    <div className="jobs-list-wrpr list-wrpr" >

                        {result?(
                        result?.map((item,index) =>
                            (
   
                                <>


                                <div className="list "  style={{background:item.publish_status === 'UNPUBLISHED'?'#f0f0f0':'#fff'}}>
                                    <div className="row">
                                        <div className="col-md-1">
                                        <div class="jobs-user">
                                        <span class="desig">Sl.No</span>
                                        {(index+1)+currentpage*10}
                                        </div>
                                        </div>
                                        
                                        <div className="col-md-3">
                                            <div className="jobs-user">
                                            <span class="desig"> Title</span>

                                            {decode(item.title)}
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="jobs-user">
                                            <span class="desig">Time and Location</span>
                                            <div class="starttime-endtime" style={{marginTop:'10px', fontSize:'15px'}}>
                                                <i class="icon-calendar6" style={{margin:0, fontSize:"13px", color:'#0068ff'}}> </i><span style={{paddingLeft:'10px'}}></span>
                                                {moment(item.start_date).format('MMMM DD, YYYY')} <i class="icon-arrow-right1" style={{ color:'#0068ff'}}></i> {moment(item.end_date).format('MMMM DD, YYYY')}
                                            </div>

                                            <div class="starttime-endtime" style={{marginTop:'10px', fontSize:'15px'}}>
                                                <i class="icon-location" style={{margin:0, fontSize:"16px", color:'#0068ff'}}> </i><span style={{paddingLeft:'10px'}}></span>
                                                {item.location}, {item.city}
                                            </div>
                                            </div>
                                        </div>

                                    
                                        <div className="col-md-4">
                                            <div className="list-action-wrpr text-right  roundicons-text event-btns" style={{marginRight:'30px', marginTop:'20px'}}>
                                             
  

                                                <Link  to={"/sessions/"+item.id} data-toggle="tooltip" title="Sessions" ><i className="edit icon-timer" style={{background:'rgb(174, 94, 186)', marginRight:'20px'}}></i><span style={{marginRight:'20px'}}>Sessions</span></Link>  

                                                <Link  to={"/view_workshop/"+item.id} data-toggle="tooltip" title="View" ><i className="edit icon-eye" style={{background:'#ff577f'}}></i><span>View</span></Link>  

                                                <button onClick={()=>{navigate("/register/workshop/"+item.id)}} style={{backgroundColor:'transparent', width:'74px' }}  data-toggle="tooltip" title="Attendees" ><a><i className="conference icon-user2 data-counts-icon" data-count={item.attendee_count} style={{background:'rgb(94, 186, 125)'}}></i><span>Attendees</span></a></button>

                                                {
                                                item.publish_status === 'UNPUBLISHED'? 
                                            
                                                    ( 

                                                        <button style={{backgroundColor:'transparent' , marginLeft:"5px"}}  data-toggle="tooltip" title="publish" onClick={(e) => { item.wno ===0?alert('Please add atleast one workshop'):PublishStatusSubmit(item.id) }} ><a><i className="delete icon-publish"></i><span>Publish</span></a></button>
                                                    ) :
                                                    (
                                                        <button disabled data-toggle="tooltip" title="unpublish" style={{backgroundColor:'transparent', marginLeft:"5px"}} onClick={(e) => { PublishStatusSubmit(item.id) } }  ><a><i className="delete icon-tick" style={{background:'#0069FF'}}></i><span>Published</span></a></button>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                           
                           
                           
                           )

                        )):null
                        }
                        {
                            !result?
                            (<div className="nodata">
                                <h2>Sorry! No Result Found</h2>
                            </div>):null
                        }
                        {result?

                        (<div class="number-of footer-number">
                            Displaying 1-{counts} of {totalItems} results.
                        </div>):null
                        }
    
                    </div>

                    { 
                        loader?
                        <div>
                            <div className="loader_container"><Loader/></div>
                        </div>
                        :
                        null
                    }

                    {result?(
                    <div class="pagination-wrpr">
                            <ReactPaginate
                                className="pagination page"
                                pageClassName="page-item"
                                activeClassName="active"
                                nextLabel=">"
                                previousLabel="<"
                                previousClassName="page-link p-link"
                                nextClassName="page-link p-link"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={10}
                                pageCount={totalPages}
                                renderOnZeroPageCount={1}
                            />
                        </div>):null
                        } 


                </div>
            </aside>
        </div>
    )
}

export default WorkshopComponent;